"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function randomString(length) {
  if (length === void 0) {
    length = 16;
  }

  var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
  var result = '';

  while (length > 0) {
    var bytes = new Uint8Array(16);
    var random = window.crypto.getRandomValues(bytes);
    random.forEach(function (c) {
      if (length === 0) {
        return;
      }

      if (c < charset.length) {
        result += charset[c];
        length--;
      }
    });
  }

  return result;
}

exports.randomString = randomString;

exports.noop = function () {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
};